import { DialogHeading } from '@ariakit/react';
import { Link } from 'react-router';

import ChevronIcon from '~/assets/icons/Chevron';
import CloseIcon from '~/assets/icons/Close';
import { DialogDismiss } from '~/components/Dialog';

const tapTargetClassName = '-m-2.5 flex size-11 items-center justify-center';

type Props = {
  colour?: 'black' | 'white';
  heading?: string;
  hideDismiss?: boolean;
  onBack?: () => void;
  onDismissHref?: string;
};

export default function ModalNav({
  colour = 'black',
  heading,
  onBack,
  onDismissHref,
  hideDismiss
}: Props) {
  return (
    <nav
      className="flex w-full flex-row items-center justify-between"
      style={{ color: colour }}
    >
      <span className="flex size-6 shrink-0 items-center justify-center">
        {onBack && (
          <button
            aria-label="Back"
            className={`${tapTargetClassName} rotate-90`}
            onClick={onBack}
            type="button"
          >
            <ChevronIcon stroke={colour} width="18" height="11" />
          </button>
        )}
      </span>

      <div className="flex w-full flex-col items-center text-center">
        {heading && (
          <DialogHeading className="font-heading text-lg font-bold leading-[26px] tracking-[-0.04em]">
            {heading}
          </DialogHeading>
        )}
      </div>

      <span className="flex size-6 shrink-0 items-center justify-center">
        {!hideDismiss &&
          (onDismissHref ? (
            <Link
              aria-label="Close"
              className={tapTargetClassName}
              to={onDismissHref}
            >
              <CloseIcon width="16" height="16" stroke={colour} />
            </Link>
          ) : (
            <DialogDismiss aria-label="Close" className={tapTargetClassName}>
              <CloseIcon width="16" height="16" stroke={colour} />
            </DialogDismiss>
          ))}
      </span>
    </nav>
  );
}
